export const locale = {
    lang: "es",
    data: {
        QUOTE: {
            QUOTE: "Cotizar",
        },
    },
};
